//系统相关
import axios from "axios"
export default {
    getNationAsync: async () => {//获取民族
        return axios.post('/get_nation_data')
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getAreaAsync: async (params) => {//获取地区
        return axios.get('/get_region', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    uploadPicAsync: async (data) => {//上传图片
        return axios.post('/user_heard_upload', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getArtAsync: async (params) => {//获取艺术门类
        return axios.get('/get_art', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getIndustryAsync: async () => {//获取行业类型
        return axios.get('/get_art',)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
    getGroupAsync: async (params) => {//获取组别
        return axios.get('/query_group', { params: params })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
}


export function loginAdmin(params){
    return axios.post('/loginAdmin',params);
}

export function getMatch(params){
    return axios.post('/getMatch',params);
}

export function exportData(params){
    return axios.post('/export_data',params);
}
